<template>
  <div class="row h-100">
    <div class="col-12 row">
      <!-- <div class="col-12">
        <ContentSection :title="galleryData.title" :paragraphs="galleryData.weekdayParagraphs" :fontType="font_type" />
      </div> -->
      <div class="col-12 mb-5 mb-md-3">
        <WeekdayImageGallery :images="galleryData.weekdayImages" :fontType="font_type" />
      </div>
    </div>

    <div class="col-12 row mb-5 mb-md-3 align-items-center">
      <div class="col-lg-4 col-md-12">
        <WeekendContentSection :title="galleryData.title" :paragraphs="galleryData.weekendParagraphs"
          :fontType="font_type" />
      </div>
      <div class="col-lg-8 col-md-12">
        <WeekendImageGallery :images="galleryData.weekendImages" :fontType="font_type" />
        <!-- <PosterSection :images="galleryData.weekendImages" :fontType="font_type" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import WeekdayPreSchoolImg from "@/assets/img/home/our-school/pre-school.jpg"
import WeekdayPrimarySchoolImg from "@/assets/img/home/our-school/primary-school.jpg"
import WeekdayMidSchoolImg from "@/assets/img/home/our-school/middle-school.jpg"
import WeekdayHighSchoolImg from "@/assets/img/home/our-school/high-school.jpg"
import WeekendPreSchoolImg from "@/assets/img/home/our-school/Weekend-Pre-School.jpg"
import WeekendPrimarySchoolImg from "@/assets/img/home/our-school/Weekend-Primary-School.jpg"
import WeekendMidSchoolImg from "@/assets/img/home/our-school/Weekend-Mid-School.jpg"
import WeekdayImageGallery from "./WeekdayImageGallery.vue"
import ContentSection from "./ContentSection.vue"
import PosterSection from "./PosterSection.vue"
import WeekendImageGallery from "./WeekendImageGallery.vue"
import WeekendContentSection from "./WeekendContentSection.vue"

export default {
  components: {
    WeekdayPreSchoolImg,
    WeekdayPrimarySchoolImg,
    WeekdayMidSchoolImg,
    WeekdayHighSchoolImg,
    WeekendPreSchoolImg,
    WeekendPrimarySchoolImg,
    WeekendMidSchoolImg,
    ContentSection,
    WeekendContentSection,
    WeekendImageGallery,
    WeekdayImageGallery,
    PosterSection,
  },

  data() {
    return {
      galleryData: {
        title: ["", "Shwe Maw Kun School Network", "ရွှေမော်ကွန်း ပညာရေးဖွံ့ဖြိုးတိုးတက်ရေးဆိုင်ရာကွန်ရက်"],
        weekdayParagraphs: [
          {
            id: 1,
            text: ["", "Maw Kun Education Group enjoys a vast and expanding network of schools across Myanmar, providing high-quality education from Pre-School to Secondary Level. Our education aids begin with nurturing early childhood development in our Pre-School, where young learners form foundations through play-based learning and inquiry-based learning. In our Primary School, our pupils are offered a well-rounded curriculum that combines key national courses with global curricula such as Singapore Math and Pearson Edexcel. At the Secondary level, we provide rigorous academic courses in addition to specialized courses like USA Curriculum Science, Computing, Coding, Arts, Music, and Mindfulness. Our network ensures consistent academic standards, trained teachers, and student-centered methods in all campuses, and we are dedicated to further growth and improving the learning process for students at each stage of their development.", `Maw Kun Education Group သည် မြန်မာနိုင်ငံအတွင်းသို့ ကျယ်ပြန့်စွာပြန့်နှံ့လာသော ပညာရေးကွန်ယက်တစ်ခုအဖြစ် တည်ရှိပြီး၊ မူကြိုအဆင့်မှ စတင်၍ အလယ်တန်းအထိ အရည်အသွေးမြင့် သင်ကြားရေးအစီအစဉ်များကို တက်ကြွစွာ ပံ့ပိုးပေးလျက်ရှိသည်။`],
          }, {
            id: 2,
            text: ["", "", "မူကြိုအဆင့်တွင် ကလေးငယ်များ၏ စဉ်းစားတွေးခေါ်မှု၊ စိတ်နေသဘောထားနှင့် အပြုအမူဖွံ့ဖြိုးမှုများကို အခြေခံကနေ ဖွံ့ဖြိုးစေရန် ရည်ရွယ်ပြီး၊ ကစားခြင်းအခြေခံသင်ယူမှု (play-based learning) နှင့် မေးခွန်းထုတ်စူးစမ်းလေ့လာသင်ယူမှု (inquiry-based learning) တို့ကို အသုံးပြုကာ သင်ကြားမှုများ ဆောင်ရွက်သည်။"],
          }, {
            id: 3,
            text: ["", "", `မူလတန်းအဆင့်တွင် နိုင်ငံ့သင်ရိုးညွှန်းတမ်းကိုအခြေခံ၍၊ Singapore Math နှင့် Pearson Edexcel ကဲ့သို့သော နိုင်ငံတကာသင်ရိုးအစီအစဉ်များကို ထည့်သွင်းပေါင်းစပ်ထားသည့် စံချိန်မြင့် သင်ရိုးညွှန်းတမ်းတစ်ခုကို ကျောင်းသား/သူများအတွက် ဆောင်ရွက်ပေးသည်။ ဤသင်ရိုးသည် ကျောင်းသား/သူများ၏ စဉ်းစားခေါင်းဆောင်မှု၊ ပြဿနာဖြေရှင်းနိုင်မှုနှင့် နိုင်ငံတကာအမြင်များ ဖွံ့ဖြိုးလာစေရန် ရည်ရွယ်ထားသည်။`],
          }, {
            id: 4,
            text: ["", "", `အလယ်တန်းအဆင့်တွင် ကျောင်းသား/သူများအတွက် သုတေသနနှင့်အခြေခံပညာရေးအတွက် ထားရှိသည့် သင်တန်းများအပြင်၊ အမေရိကန်သင်ရိုးအခြေခံသိပ္ပံဘာသာရပ်၊ ကွန်ပျူတာသင်ကြားမှု၊ ကုဒ်ရေးသားခြင်း (coding)、အနုပညာ၊ တေးဂီတနှင့် စိတ်ကြည်လင်အေးချမ်းမှု (mindfulness) တို့အပါအဝင် ထူးခြားသည့်ဘာသာရပ်များကိုလည်း ထည့်သွင်းသင်ကြားပေးသည်။`],
          }, {
            id: 5,
            text: ["", "", `Maw Kun Education Group ၏ ကျောင်းကွန်ယက်သည် မည်သည့်သင်တန်းကျောင်းအဆင့်တွင်မဆို ပညာရေးအရ အညီအမျှဖြစ်စေရန် စံပြသင်ကြားမှုစနစ်များ၊ လေ့ကျင့်သင်ကြားမှုတတ်မြောက်သည့် ဆရာ/ဆရာမများနှင့် ကျောင်းသား/သူဦးစားပေး သင်ကြားမှုနည်းဗျူဟာများကို တစ်သမတ်တည်းအသုံးပြုထားသည်။ ကျွန်ုပ်တို့သည် ကျောင်းသား/သူတစ်ဦးချင်းစီ၏ ဖွံ့ဖြိုးတိုးတက်မှုအဆင့်အလိုက် သင်ယူမှုအရည်အသွေးကို တိုးတက်ကောင်းမွန်အောင် ဆောင်ရွက်နိုင်ရေးအတွက် အထူးအာရုံစိုက်လျက်ရှိသည်။`],
          }
        ],
        weekendParagraphs: [
          {
            id: 1,
            text: ["", "Maw Kun Education Group offers the Weekend International Programme from July to February and Summer Classes from March to May. These programs provide academic enrichment beyond the regular school year. Students study Cambridge English and international subjects like Pearson Mathematics, Science, and Computing. They also engage in Coding and STEM activities to enhance critical thinking and problem-solving skills. The programs reflect the school’s commitment to delivering a well-rounded, globally focused education.", `Maw Kun Education Group သည် ပညာရေးအရ စွမ်းဆောင်ရည်မြှင့်တင်ရေးကို ရည်ရွယ်၍ ဇူလိုင်လမှ ဖေဖော်ဝါရီလအထိ Weekend International Programme ၊ မတ်လမှ မေလအထိ Summer Programme ကို စဉ်ဆက်မပြတ် ဖွင့်လှစ်လျက်ရှိသည်။`],
          }, {
            id: 2,
            text: ["", "", `ကျောင်းသား/သူများသည် Cambridge English သင်ရိုးအပြင် Pearson Edexcel မှထုတ်ဝေသော သင်္ချာ၊ သိပ္ပံနှင့် ကွန်ပျူတာသင်ကြားမှုတို့ကိုလည်း အဓိကထား၍ လေ့လာကြသည်။ ထို့အပြင် Coding နှင့် STEM (သိပ္ပံ၊ နည်းပညာ၊ အင်ဂျင်နီယာနှင့် သင်္ချာ) ဆိုင်ရာ လှုပ်ရှားမှုများတွင်ပါဝင်စေခြင်းအားဖြင့် ကျောင်းသား/သူများ၏ ခေတ်မီစဉ်းစားနိုင်စွမ်း၊ ပြဿနာဖြေရှင်းနိုင်မှုနှင့် နည်းပညာတတ်ကျွမ်းမှုတို့ ဖွံ့ဖြိုးတိုးတက်စေရန် ရည်ရွယ်ထားသည်။`],
          }, {
            id: 3,
            text: ["", "", `ဤအစီအစဉ်များသည် ပညာရေးအရည်အသွေးတိုးတက်မှုအပေါ် တာဝန်ယူမှုနှင့် ကမ္ဘာ့စံနှုန်းနှင့် ကိုက်ညီသော တစ်ဦးချင်းစီအခြေပြု သင်ကြားမှုပေးနိုင်ရေးဆိုင်ရာ ကျောင်း၏ ရည်မှန်းချက်ကို တိကျသေချာစွာ ထင်ဟပ်စေသည်။`],
          },
        ],
        weekdayImages: [
          {
            id: 1,
            src: WeekdayPreSchoolImg,
            href: "AcademicWeekdayPreSchool",
            text: ["", "PRE-SCHOOL", "မူလတန်းကြိုကျောင်း"],
            age: ["", "Age 3 - 5", "အသက် ၃ - ၅"],
          },
          {
            id: 2,
            src: WeekdayPrimarySchoolImg,
            href: "AcademicWeekdayPrimary",
            text: ["", "PRIMARY SCHOOl", "မူလတန်း"],
            age: ["", "Age 5 - 12", "အသက် ၅ - ၁၂"],
          },
          {
            id: 3,
            src: WeekdayMidSchoolImg,
            href: "AcademicWeekdaySecondary",
            text: ["", "MIDDLE SCHOOL", "အလယ်တန်း"],
            age: ["", "Age 12 - 14", "အသက် ၁၂ - ၁၄"],
          },
          {
            id: 4,
            src: WeekdayHighSchoolImg,
            href: "AcademicWeekdayHigh",
            text: ["", "HIGH SCHOOL", "အထက်တန်း"],
            age: ["", "Age 15 - 18", "အသက် ၁၅ - ၁၈"],
          }
        ],
        weekendImages: [
          {
            id: 1,
            src: WeekendPreSchoolImg,
            href: "AcademicWeekendPreSchool",
            text: ["", "PRE-SCHOOL", "မူလတန်းကြိုကျောင်း"],
            age: ["", "Age 3 - 5", "အသက် ၃ - ၅"],
          },
          {
            id: 2,
            src: WeekendPrimarySchoolImg,
            href: "AcademicWeekendPrimary",
            text: ["", "PRIMARY SCHOOl", "မူလတန်း"],
            age: ["", "Age 5 - 12", "အသက် ၅ - ၁၂"],
          },
          {
            id: 3,
            src: WeekendMidSchoolImg,
            href: "AcademicWeekendSecondary",
            text: ["", "MIDDLE SCHOOL", "အလယ်တန်း"],
            age: ["", "Age 12 - 14", "အသက် ၁၂ - ၁၄"],
          },
        ],
      }
    }
  },

  computed: {
    font_type() {
      return this.$store.state.font_type;
    },
  },
}
</script>
